import { useAdminUpdate } from '@reapitform/hooks'
import { AdminRecipientField, AdminRecipientFieldPayload } from '../types'

/** Creates a recipient field under a recipient card (`POST /recipient-cards/{cardRef}/fields`). */
export const useCreateAdminRecipientField = (recipientCardReferenceID: string) =>
  useAdminUpdate<AdminRecipientFieldPayload, AdminRecipientField>({
    path: `/api/recipient-cards/${recipientCardReferenceID}/fields`,
    method: 'POST',
    errorMessage: 'Failed to create the recipient field',
    successMessage: 'Recipient field created',
  })
